import { Navigate } from 'react-router-dom';

import App from 'src/app';
import { CONFIG } from 'src/config-global';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

// Route tree consumed by createBrowserRouter in main.jsx. App is the root
// layout — it renders all the global providers + an <Outlet /> for the rest
// of the tree.
export const routes = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <Navigate to={CONFIG.auth.redirectPath} replace />,
      },

      // Auth
      ...authRoutes,

      // Dashboard
      ...dashboardRoutes,

      // Main
      ...mainRoutes,

      // No match
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];
